// Swiper Icons Ticker Slider Start  
  document.addEventListener('DOMContentLoaded',function(){
    let SwiperTop = new Swiper('.WrapperCertifiedIc__PuPw.swiper', {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 16000,
      autoplay: {
       delay: 1,
      },
      loop: true,
  loopedSlides: 4,
  slidesPerView:'auto',
  allowTouchMove: false
 
});
  })  


// Homepage Product collection
 $(document).ready(function() {
        $('.OurProduct_Cotegory').on('click', function() {
          $('.OurFeatured_Cotegory').css('color','#000');
           $('.OurFeatured_Cotegory').css('border-bottom', 'none');
           $(this).css('color','#204590');
           $(this).css('border-bottom', '1px solid #204590');
            $('.OurProduct_ImagSec1').fadeIn(450); // Adjust duration as needed (450 milliseconds used here)
            $('.OurProduct_ImagSec2').fadeOut(450); // Adjust duration as needed (450 milliseconds used here)
        });

        $('.OurFeatured_Cotegory').on('click', function() {
          $('.OurProduct_Cotegory').css('color','#000');
           $('.OurProduct_Cotegory').css('border-bottom', 'none');
           $(this).css('color','#204590');
           $(this).css('border-bottom', '1px solid #204590');
            $('.OurProduct_ImagSec1').fadeOut(450); // Adjust duration as needed (450 milliseconds used here)
            $('.OurProduct_ImagSec2').fadeIn(450); // Adjust duration as needed (450 milliseconds used here)
        });
    });

// Collection Page Js

// $(document).ready(function(){
// $(document).on('click','.KK_Collimxont',function(){
// $(this).addClass('active').siblings().removeClass('active');
// // $(this).parents('.KK_CollContainer').children('.KK_CollecProdc').eq($(this).index()).addClass('active').siblings().removeClass('active');
// $(this).parent('.KK_CollContainer').children('.custom_navigation').eq($(this).index()).addClass('active').siblings().removeClass('active');
// });
// $(document).ready(function() {
//   $('.KK_Collimxont').eq(0) .trigger('click');
// });
 
// });

// $(document).ready(function(){
//   $(document).on('click','.KK_Collimxont',function(){
//     $(this).addClass('active').siblings().removeClass('active');
//     $('.KK_CollimxontCvc').removeClass('active');
//     $(this).closest('.KK_CollContainer').find('.custom_navigation').eq($(this).index()).addClass('active').siblings().removeClass('active');
// $('facet-remove.active-facets__button-wrapper a span').trigger('click');
//     $('.NavigationOutrPro').css('display','block');
//   });

//   $(document).ready(function() {
//     $('.KK_Collimxont').eq(0).trigger('click');
//   });
// });



// $(document).ready(function(){
//     $(document).on('click','.KK_CollimxontCvc',function(){
//     $(this).addClass('active').siblings().removeClass('active');
//      $('.KK_Collimxont ').removeClass('active');
//     $(this).closest('.KK_CollContainer').find('.CustSeldgg').eq($(this).index()).addClass('active').siblings().removeClass('active');
// $('.NavigationOutrPro').css('display','none');
//        $('facet-remove.active-facets__button-wrapper a span').trigger('click');
// });
//   // $('.kktitple1').addClass('active');

  
//   });



// KARI_COLLECTION PAGE Matching js
 
// $(document).on('click', ".kkcustom_navigation", function() {
//   $(this).addClass('active').siblings().removeClass('active');
//  var productType = $(this).text(), productType = $.trim(productType);
//     $('.grid_kkitem').each(function() {
//       $(this).hide();
//       var itemProductType = $(this).attr('product-type'), itemProductType = $.trim(itemProductType);
        
//         if (itemProductType === productType) {
//           $(this).addClass('active').siblings().removeClass('active')

//         // $(this).show(); // Show grid items with matching product type
//         }
//     });
// });
// $(document).on('click', ".kkcustom_navigation", function() {
//   $(this).addClass('active').siblings().removeClass('active');
//   var productType = $(this).text().trim();
//   $('.grid_kkitem').hide().removeClass('active'); // Hide all grid items initially 
//   $('.grid_kkitem[product-type="' + productType + '"]').addClass('active').show();
// });


// Social Page View More Button Js
  $(document).ready(function(){
  $('.KK_MemMorBtn').on('click', function() {
  $('.KK_MereImageOutr').fadeToggle(450);
  });
  });

// Slick slider mobile Homepage patron icons
$(document).ready(function(){
  if( $(window).width() < 750 ){
    $('.KKPatrons_IconCont').not('.slick-initialized').slick({dots: true,arrows: false,  infinite: true,slidesToShow: 3,rows:0,arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true
    
 });
  }
    window.addEventListener('resize', ()=>{
      if( $(window).width() < 750 ){
      $('.KKPatrons_IconCont').not('.slick-initialized').slick({dots: true,arrows: false,  infinite: true,slidesToShow: 3,rows:0,arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: "linear",
    pauseOnHover: true
     
  }); 
      }else{
        $('.KKPatrons_IconCont').slick('unslick');   
      }
    })

  
  });



// Social page Social section slider
 $(document).ready(function() {
  // Function to initialize the slick slider
   function initSlider() {
      $('.KK_SociFlxd').slick({
        dots: false,
        arrows: false,
        infinite: false,
       slidesToShow: 1.3, // Change slidesToShow to 1.5 or 1.7 as needed
        rows: 0
      });
    }

    // Check window width on page load
    
   if ($(window).width() < 750) {
      initSlider();         // Initialize the slider if window width is less than 750 pixels
    }

    // Check window width on window resize
    
   $(window).resize(function() {
      
     if ($(window).width() < 750 && !$('.KK_SociFlxd').hasClass('slick-initialized')) {
        
       initSlider(); // Initialize the slider if window width is less than 750 pixels and it's not initialized
      
     } else if ($(window).width() >= 750 && $('.KK_SociFlxd').hasClass('slick-initialized')) {
        
       $('.KK_SociFlxd').slick('unslick'); // Unslick the slider if window width is 750 or more
      }
    });

  
});

// PDP ACCORDIAN close automaticaly on window < 749 bydefault open content
  // Example assuming jQuery is used:

 $(document).ready(function(){
   if ($(window).width() < 749) {
  $('.kkcontmnt').removeAttr('open');
      }
  });


// Social Science Momments EXHIBITION Secion SLIDER

$(document).ready(function(){
    // Function to initialize slick slider
       function initializeSlick() {
    $('.KK_MemImageOutr').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3.5,
        rows: 0, // Show 3.5 images on desktop
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: "linear",
        pauseOnHover: false,
        responsive: [{
            breakpoint: 769, // Breakpoint for mobile view
            settings: {
                swipeToSlide: true,
                speed: 1200,
                draggable: true,
                autoplay: true, // Set autoplay to true for continuous sliding
                cssEase: "ease",
                autoplaySpeed: 800,
                centerMode: true,
                arrows: true,
               pauseOnHover: false,
                prevArrow: '<button id="prevArrowTemplate" class="CustomcolPrevious slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></button>',
                nextArrow: '<button id="nextArrowTemplate" class="Customcolnext slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></button>',
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }]
    });
}

// Initialize slick slider
initializeSlick();


    // Re-initialize slick slider on window resize
   
  // $(window).on('resize', function() {
       
  //   if ($(window).width() < 769) {
           
  //     $('.KK_MemImageOutr').slick('slick');
  //           initializeSlick();
       
  //   } else {
  //           $('.KK_MemImageOutr').slick('slick');
  //       }
  //   });



// Collection page Mobile section products images slider

  if( $(window).width() < 750 ){
    $('.KK_collBleow').not('.slick-initialized').slick({dots: true,arrows: true, prevArrow: '<button id="prevArrowTemplate" class="CustomcolPrevious slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></button>',nextArrow: '<button id="nextArrowTemplate" class="Customcolnext slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></button>', infinite: false,slidesToShow: 2.5,rows:0});
  }

  window.addEventListener('resize', ()=>{
    
    if( $(window).width() < 750 ){
        $('.KK_collBleow').not('.slick-initialized').slick({dots: true,arrows: true, prevArrow: '<button id="prevArrowTemplate" class="CustomcolPrevious slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></button>', nextArrow: '<button id="nextArrowTemplate" class="Customcolnext slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></button>', infinite: false,slidesToShow: 2.5,rows:0}); 
     
    }else{
        $('.KK_collBleow').slick('unslick');   
      }
    });

  function is_touch_device() {
    return 'ontouchstart' in window
        || navigator.maxTouchPoints;
  };

var scrollDuration = 300;var leftPaddle = document.getElementsByClassName('iconltl');var rightPaddle = document.getElementsByClassName('iconrtl');var menuSize = 0;
  var itemsLength = $('.KK_CollBMaincont .CommanMainCl').each(function(){menuSize+=$(this).outerWidth(true);});
  var paddleMargin = 20;var down = false;
  var getMenuWrapperSize = function() {return $('.CustomCollection_COnt').outerWidth();}
  var menuWrapperSize = getMenuWrapperSize();
  $(window).on('resize', function() {menuWrapperSize = getMenuWrapperSize();});
  var menuInvisibleSize = menuSize - menuWrapperSize;
  var getMenuPosition = function() {
  	return $('.KK_CollBMaincont').scrollLeft(); 
  };
  $('.KK_CollBMaincont').on('scroll', function() {
  	menuInvisibleSize = menuSize - menuWrapperSize;
  	var menuPosition = getMenuPosition();
  	var menuEndOffset = menuInvisibleSize - paddleMargin;
  	if (menuPosition <= paddleMargin) {
  		$(leftPaddle).addClass('mouted');
  		$(rightPaddle).removeClass('mouted');
  	} else if (menuPosition < menuEndOffset) {
  		$(leftPaddle).removeClass('mouted');
  		$(rightPaddle).removeClass('mouted');
  	} else if (menuPosition >= menuEndOffset) {
  		$(leftPaddle).removeClass('mouted');
  		$(rightPaddle).addClass('mouted');
    }
  });
  
  $(rightPaddle).on('click', function() {
  	$('.KK_CollBMaincont').animate( { scrollLeft: $('.KK_CollBMaincont').scrollLeft()+150}, scrollDuration);
  });
  $(leftPaddle).on('click', function() {
  	$('.KK_CollBMaincont').animate( { scrollLeft: $('.KK_CollBMaincont').scrollLeft()-150 }, scrollDuration);
  });
  if(!is_touch_device()){
  	var nav_out_timer;
  	$(".KK_CollBMaincont").mousedown(function(e){
  		e.preventDefault();e.stopPropagation();down=true;x=e.pageX;y=e.pageY;left=$(this).scrollLeft();
  	});
  	$(".CustomCollection_COnt").mouseover(function(e){window.clearTimeout(nav_out_timer);});
  	$(".CustomCollection_COnt").mouseout(function(e){nav_out_timer = window.setTimeout(function(){down = false;},100);});
  	$("body").mousemove(function(e){
    if(down){var newX=e.pageX;$(".KK_CollBMaincont").scrollLeft(left-newX+x);}
  	});
  	$(".KK_CollBMaincont").on('mouseup',function(e){
  		if(down){e.preventDefault();e.stopPropagation();down=false;}
  	});
  	$(".KK_CollBMaincont a").on('click',function(e){
  		if(Math.abs(left-$(".KK_CollBMaincont").scrollLeft()) !== 0 ){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();return false;}
  	});
  	$('.KK_CollBMaincont a').each(function(){
          var existing_event = this.onclick;
          this.onclick = null;
          $(this).click(function(e){ 
              if($(this).hasClass('disabled')){e.stopImmediatePropagation();e.preventDefault();}                
          });
          if(existing_event){$(this).click(existing_event);}
  	});
  }


//   $(document).on('click','.kkcustom_navigation',function(){
//     $('facet-remove.active-facets__button-wrapper a span').trigger('click');
// var gettype = $(this).attr('data-type'); 
//     $('.mobile-facets__item[data-type="'+gettype +'"] label').trigger('click');
// });

  $(document).on('click','.accordion__content .metafield-rich_text_field a',function(e){
    e.preventDefault();
var getmetafied = $(this).attr('href');
    if(getmetafied == '#Enqure_tab'){
 $('.KariEnquirPop_MainContaner').fadeToggle(100);
    $('body').css('overflow', 'hidden'); // Disable scrolling when opening the popup
   
    if ($(window).width() > 749 ) {
      $('body').css('overflow', 'hidden'); // Disable scrolling when opening the popup
    } else {
      $('body').css('overflow', 'hidden'); // Enable scrolling when opening the popup
    }
        
    }
    
});

  var getload = window.location.hash;
if (getload != '') {
    var finalvl = getload.split('#')[1];
    $('.KK_Collimxont').removeClass('active');
    $('.custom_navigation').removeClass('active');
  $('.KK_CollimxontCvc').removeClass('active');
    $('.KK_Collimxont[url-handle="' + finalvl + '"]').addClass('active').click();
    $('.custom_navigation[url-handle="' + finalvl + '"]').addClass('active');
  $('.KK_CollimxontCvc[url-handle="' + finalvl + '"]').addClass('active').click();
  
    window.history.replaceState(null, null, ' '); 
}


 $(".field__input").focus(function () {
     $(".field__input").each(function() {
       if($(this).val().length == 0){
     $(this).parents(".Cv_Phne").removeClass("input_focused"); 
       }
     });
     $(this).parents(".Cv_Phne").addClass("input_focused");
        });

  $(".field__input").focus(function () {
     $(".field__input").each(function() {
       if($(this).val().length == 0){
     $(this).parents(".CustomPhon").removeClass("input_focused"); 
       }
     });
     $(this).parents(".CustomPhon").addClass("input_focused");
        });
  
$(document).on('click', '.brochureDownload',function(e){
  e.preventDefault(); 
    var pdflink = $(this).attr('href');
    $.ajax({
      url: pdflink,
      method: 'GET',
      xhrFields: {
        responseType: 'blob'
      },
      success: function (data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = 'brochure.pdf';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    });
  
});


  $(document).on('click', '.brochureDownloadget',function(e){
  e.preventDefault();
    var pdflink = $(this).attr('href');
    $.ajax({
      url: pdflink,
      method: 'GET',
      xhrFields: {
        responseType: 'blob'
      },
      success: function (data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = 'brochure.pdf';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    });
  
});
  

  
});


// product catalouge page 

document.querySelectorAll('.KK_CollimxontCvc').forEach( (elm)=>{
  elm.addEventListener('click', (target)=>{
     target.preventDefault();
     let COL_HANDLE = target.currentTarget.getAttribute('data-handle');   
      document.querySelectorAll('.KK_Collimxont').forEach( (elm)=>{ elm.classList.remove('active'); });
      document.querySelectorAll('.KK_CollimxontCvc').forEach( (elm)=>{ elm.classList.remove('active'); }); 
      target.currentTarget.classList.add('active'); 
      document.querySelectorAll('.custom_navigation').forEach( (elm)=>{ elm.classList.remove('active'); });
      fetch(`${COL_HANDLE}`, {
        method:'GET',
      }).then( response =>{
        return response.text();
      }).then( (result) =>{
        const HTML_TAGGED = new DOMParser().parseFromString(result, 'text/html');
        const FOUND_HTML_TAGGED  = HTML_TAGGED.querySelector('#ProductGridContainer').innerHTML;
        const FOUND_HTML_COUNT  = HTML_TAGGED.querySelector('#ProductCount').innerHTML;
        document.querySelector('#ProductGridContainer').innerHTML = FOUND_HTML_TAGGED;
        document.querySelector('#ProductCount').innerHTML = FOUND_HTML_COUNT;
        var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  offset: 1000
});
                              var AjaxinatePagination_html = $('#AjaxinatePagination').html();
   var teimtext = $.trim(AjaxinatePagination_html);
                  if(teimtext == ''){
  $('.endScroll').show();
}
      })	    
  });
});



  
document.querySelectorAll('.KK_Collimxont').forEach( (elm)=>{
  elm.addEventListener('click', (target)=>{
    target.preventDefault();
    let COL_HANDLE = target.currentTarget.getAttribute('data-handle');   
    document.querySelectorAll('.KK_Collimxont').forEach( (elm)=>{ elm.classList.remove('active'); });
    document.querySelectorAll('.KK_CollimxontCvc').forEach( (elm)=>{ elm.classList.remove('active'); });    
    target.target.classList.add('active'); 
    target.currentTarget.classList.add('active'); 
    document.querySelectorAll('.custom_navigation').forEach( (elm)=>{ elm.classList.remove('active'); });
    document.querySelector(`.custom_navigation[data-handle="${COL_HANDLE}"]`).classList.add('active');
    document.querySelector(`.custom_navigation[data-handle="${COL_HANDLE}"]`).children[0].classList.add('active');
    fetch(`${COL_HANDLE}`, {
      method:'GET',
    }).then( response =>{
      return response.text();
    }).then( (result) =>{
      const HTML_TAGGED = new DOMParser().parseFromString(result, 'text/html');
      const FOUND_HTML_TAGGED  = HTML_TAGGED.querySelector('#ProductGridContainer').innerHTML;
      const FOUND_HTML_COUNT  = HTML_TAGGED.querySelector('#ProductCount').innerHTML;
      document.querySelector('#ProductGridContainer').innerHTML = FOUND_HTML_TAGGED;
      document.querySelector('#ProductCount').innerHTML = FOUND_HTML_COUNT;
      var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  offset: 1000
});
                            var AjaxinatePagination_html = $('#AjaxinatePagination').html();
   var teimtext = $.trim(AjaxinatePagination_html);
                  if(teimtext == ''){
  $('.endScroll').show();
}
    })	
  })
})


document.querySelectorAll('.kkcustom_navigation').forEach( (elm)=>{
  elm.addEventListener('click', (target)=>{
    target.preventDefault();
    document.querySelectorAll('.kkcustom_navigation').forEach( (elmset)=>{ elmset.classList.remove('active') });
    target.currentTarget.classList.add('active');
    let CollectionMap = target.target.closest('.custom_navigation').getAttribute('data-handle');
	if ( target.currentTarget.getAttribute('data-type').includes('All') ){
		fetch(`${CollectionMap}`, {
		  method:'GET',
		}).then( response =>{
		  return response.text();
		}).then( (result) =>{
		  const HTML_TAGGED = new DOMParser().parseFromString(result, 'text/html');
		  const FOUND_HTML_TAGGED  = HTML_TAGGED.querySelector('#ProductGridContainer').innerHTML;
          const FOUND_HTML_COUNT  = HTML_TAGGED.querySelector('#ProductCount').innerHTML;
		  document.querySelector('#ProductGridContainer').innerHTML = FOUND_HTML_TAGGED;
          document.querySelector('#ProductCount').innerHTML = FOUND_HTML_COUNT;
          var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  offset: 1000
});
		})	
	}
	else{
		let DataType = target.currentTarget.getAttribute('data-type');
		fetch(`${CollectionMap}?filter.v.price.gte=&filter.v.price.lte=&filter.p.product_type=${DataType}&sort_by=best-selling`, {
		  method:'GET',
		}).then( response =>{
		  return response.text();
		}).then( (result) =>{
		  const HTML_TAGGED = new DOMParser().parseFromString(result, 'text/html');
		  const FOUND_HTML_TAGGED  = HTML_TAGGED.querySelector('#ProductGridContainer').innerHTML;
          const FOUND_HTML_COUNT  = HTML_TAGGED.querySelector('#ProductCount').innerHTML;
		  document.querySelector('#ProductGridContainer').innerHTML = FOUND_HTML_TAGGED;
          document.querySelector('#ProductCount').innerHTML = FOUND_HTML_COUNT;
          var endlessScroll = new Ajaxinate({
  container: '#product-grid',
  pagination: '#AjaxinatePagination',
  offset: 1000
});
                                var AjaxinatePagination_html = $('#AjaxinatePagination').html();
   var teimtext = $.trim(AjaxinatePagination_html);
                  if(teimtext == ''){
  $('.endScroll').show();
}
		})
	}
  })
})